var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCommentFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 18,
  viewBox: "0 0 18 18",
  width: 18,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 .5A2.496 2.496 0 0 1 16.5 3v9c0 .69-.28 1.315-.732 1.768A2.492 2.492 0 0 1 14 14.5H4.764L.5 17.108V3c0-.69.28-1.315.732-1.768A2.492 2.492 0 0 1 3 .5z",
  fill: "currentColor",
  fillOpacity: 0.15,
  stroke: "currentColor"
})));
export default SvgIconCommentFilled;